import { render, staticRenderFns } from "./BomView.vue?vue&type=template&id=3dc9fa2f&"
import script from "./BomView.vue?vue&type=script&lang=js&"
export * from "./BomView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports